import {
  ChangeMcpAccessResponseSchema,
  McpAccessAccountListSchema,
  type McpToolName,
} from '@youkuai/contracts';

import { apiRequest } from './project-api.ts';

export async function listMcpAccessAccounts(token: string) {
  return McpAccessAccountListSchema.parse(await apiRequest('/system/mcp-access', token));
}

export async function changeMcpAccess(token: string, accountId: string, input: {
  expectedVersion: number;
  enabled: boolean;
  allowedTools: McpToolName[];
  expiresAt: string | null;
  reason: string;
}) {
  return ChangeMcpAccessResponseSchema.parse(await apiRequest(
    `/system/mcp-access/${encodeURIComponent(accountId)}`,
    token,
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Idempotency-Key': `mcp-access-${crypto.randomUUID()}` },
      body: JSON.stringify(input),
    },
  ));
}
